import { GetEventFieldsResponseSchema } from '@weft/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useEventFields(eventName: string) {
  return useQuery(
    ['eventFields', eventName],
    async () => {
      const privateApi = getPrivateApi();
      const getEventFieldsResponse = await privateApi.getEventFields({ eventName });

      return GetEventFieldsResponseSchema.parse(getEventFieldsResponse);
    },
  );
}